import { snapdom, type SnapdomOptions } from '@zumer/snapdom';
import i18next from 'i18next';

export interface SocialMediaShareData {
    url: string;
    title: string;
    text: string;
}

export function GetNavigatorShareData(url: string): SocialMediaShareData {
    return {
        url,
        title: i18next.t('share.title'),
        text: i18next.t('share.text'),
    };
};

export function SocialMediaShare(data: SocialMediaShareData) {
    if (navigator.share && navigator.canShare(data)) {
        navigator.share(data).catch(() => { });
    }
}

export async function domScreenshotShare(element: HTMLElement, imageName: string, options: SnapdomOptions) {
    // Allow the modal hide to render before capturing the board.
    await new Promise<void>((resolve) => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));

    const result = await snapdom(element, options);
    const blob = await result.toBlob();

    if (!blob) {
        throw new Error('Failed to render board to image');
    }

    const file = new File([blob], `${imageName}.png`, { type: 'image/png' });
    const shareData = GetNavigatorShareData(window.location.href);

    try {
        if (navigator.share && navigator.canShare({ files: [file] })) {
            await navigator.share({
                ...shareData,
                files: [file],
            });
        }
    } catch (shareError) {
        await result.download({ filename: imageName });
    }

    return result;
}
